// test1337
(1337 && 0);
